/* eslint-disable no-param-reassign */

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface NotificationStateProperties {
  type: 'error' | 'success' | null;
  notificationDetails: {
    statusCode: number | null;
    message: string | null;
  };
}

const initialState: NotificationStateProperties = {
  type: null,
  notificationDetails: {
    statusCode: null,
    message: null,
  },
};

/**
 * Notification Slice
 */
export const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    /**
     * Function to set error notification
     * @param {any} state - The current state.
     * @param {any} action - The action object.
     */
    setNotificationDetails: (state, action: PayloadAction<NotificationStateProperties>) => {
      state.type = action.payload.type;
      state.notificationDetails = action.payload.notificationDetails;
    },
    /**
     * Function that sets the notification to initial state
     * @param {any} state - The current state.
     */
    resetNotificationToInitialState: (state) => {
      Object.assign(state, initialState);
    },
  },
});

export const { setNotificationDetails, resetNotificationToInitialState } =
  notificationSlice.actions;

export default notificationSlice.reducer;
